import React from "react";
import { lessonTimeline } from "../data/content";
export function LessonExample() {
  return <section className="px-4 py-14 sm:px-5 sm:py-20" data-id="element-89" data-mp="kxykey8s096b">
      <div className="mx-auto max-w-2xl" data-id="element-90" data-mp="kzjigxuaua8x">
        <h2 className="text-center font-display text-3xl uppercase leading-tight text-cream sm:text-5xl" data-id="element-91" data-mp="yxrb4tkaypea">
          Votre prochain cours, <span className="text-gold" data-id="element-92" data-mp="txddm5gbuxui">prêt en 5 minutes</span>
        </h2>
        <ol className="relative mt-10 space-y-6 border-l-2 border-line pl-6 sm:pl-8" data-id="element-93" data-mp="17x4ldog93i02">
          {lessonTimeline.map((step, i) => {
          const isLast = i === lessonTimeline.length - 1;
          return <li key={step.time} className="relative" data-id="element-94" data-mp="1hmecp239swn4" data-mpi={i}>
                <span className={`absolute -left-[33px] top-1 h-4 w-4 rounded-full border-2 sm:-left-[41px] ${isLast ? "border-gold bg-gold" : "border-gold bg-ink"}`} aria-hidden data-id="element-95" data-mp="1comp2k9nrwoq" />
                <p className="font-display text-xl text-gold" data-id="element-96" data-mp="1mnvd6whueh36">{step.time}</p>
                <p className={`mt-1 ${isLast ? "font-semibold text-cream" : "text-mute"}`} data-id="element-97" data-mp="3zrepfsvuupu">{step.text}</p>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}